import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PurchaseOrders from './PurchaseOrders';
import SalesOrders from './SalesOrders';
import Suppliers from './Suppliers';
import Customers from './Customers';
import StockTransfers from './StockTransfers';
import Shipments from './Shipments';
import Receipts from './Receipts';
import ReturnOrders from './ReturnOrders';
// import InventoryAdjustments from './InventoryAdjustments';
import CycleCounts from './CycleCounts';
import StockReservations from './StockReservations';
import '../inventory.css';
import '../ProductManagement/ProductForm.css';
import './operations.css';

const Operations = ({ organization }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(() => {
    // Load saved tab from localStorage
    const saved = localStorage.getItem(`operations_activeTab_${organization}`);
    return saved || 'purchaseOrders';
  });

  // Save active tab to localStorage whenever it changes
  useEffect(() => {
    if (organization) {
      localStorage.setItem(`operations_activeTab_${organization}`, activeTab);
    }
  }, [activeTab, organization]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'purchaseOrders':
        return <PurchaseOrders organization={organization} />;
      case 'salesOrders':
        return <SalesOrders organization={organization} />;
      case 'suppliers':
        return <Suppliers organization={organization} />;
      case 'customers':
        return <Customers organization={organization} />;
      case 'stockTransfers':
        return <StockTransfers organization={organization} />;
      case 'shipments':
        return <Shipments organization={organization} />;
      case 'receipts':
        return <Receipts organization={organization} />;
      case 'returnOrders':
        return <ReturnOrders organization={organization} />;
      // case 'inventoryAdjustments':
      //   return <InventoryAdjustments organization={organization} />;
      case 'cycleCounts':
        return <CycleCounts organization={organization} />;
      case 'stockReservations':
        return <StockReservations organization={organization} />;
      default:
        return <PurchaseOrders organization={organization} />;
    }
  };

  // Show message if no organization is available
  if (!organization) {
    return (
      <div className="pm-page-card">
        <div className="pm-empty-state">
          <div className="pm-empty-state-icon" aria-hidden="true">⚠️</div>
          <h3>{t('inventory.operations_title')}</h3>
          <p>{t('inventory.no_organization_warning')}</p>
        </div>
      </div>
    );
  }

  const tabs = [
    { key: 'purchaseOrders', label: t('inventory.tab_purchase_orders'), icon: '📝' },
    { key: 'salesOrders', label: t('inventory.tab_sales_orders'), icon: '🛒' },
    { key: 'suppliers', label: t('inventory.tab_suppliers'), icon: '🏭' },
    { key: 'customers', label: t('inventory.tab_customers'), icon: '👥' },
    { key: 'stockTransfers', label: t('inventory.tab_stock_transfers'), icon: '🔄' },
    { key: 'shipments', label: t('inventory.tab_shipments'), icon: '🚚' },
    { key: 'receipts', label: t('inventory.tab_receipts'), icon: '📦' },
    { key: 'returnOrders', label: t('inventory.tab_returns'), icon: '↩️' },
    { key: 'cycleCounts', label: t('inventory.tab_cycle_counts'), icon: '🔢' },
    { key: 'stockReservations', label: t('inventory.tab_reservations'), icon: '🔒' },
  ];

  return (
    <div>
      <div className="pm-tabs">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`pm-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
            title={tab.label}
          >
            <span aria-hidden="true">{tab.icon}</span>
            <span className="desktop-only">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Operations;
